import {useEffect, useState} from 'react';
import {setDimensionToGA4} from '../service/gtagHelpers';

const windowIsDefined = typeof window !== 'undefined';

// @ts-ignore
const isAndroid = !!(windowIsDefined && window?.native);
// @ts-ignore
const isIos = !!(windowIsDefined && window?.webkit?.messageHandlers?.native);

const useGA4Dimensions = () => {
  const [connectionStatus, setConnectionStatus] = useState('');

  useEffect(() => {
    let app = 'false';
    if (isAndroid) {
      app = 'android';
    } else if (isIos) {
      app = 'ios';
    }
    const ga4Platform = app === 'false' ? 'web' : app;
    setDimensionToGA4({user_properties: {fupa_platform: ga4Platform}});
  }, []);

  function updateConnectionStatus() {
    // @ts-ignore
    setConnectionStatus(navigator.connection.effectiveType);
  }

  useEffect(() => {
    // @ts-ignore
    if (navigator?.connection?.effectiveType) {
      // @ts-ignore
      setConnectionStatus(navigator.connection.effectiveType);
      // @ts-ignore
      navigator.connection.addEventListener('change', updateConnectionStatus);
    } else {
      setConnectionStatus('not supported');
    }
  }, []);

  useEffect(() => {
    if (connectionStatus) {
      setDimensionToGA4({user_properties: {fupa_connection_status: connectionStatus}});
    }
  }, [connectionStatus]);
};

export default useGA4Dimensions;
